import React, { useMemo } from "react";
import {
  FaClock,
  FaMapMarkerAlt,
} from "react-icons/fa";

const EntriesTable = ({
  entries = [],
  selectedEntries = [],
  setSelectedEntries,
}) => {
  const entryIds = useMemo(
    () =>
      entries
        .map((entry) => Number(entry.id))
        .filter((id) => Number.isInteger(id)),
    [entries]
  );

  const allSelected =
    entryIds.length > 0 &&
    entryIds.every((id) => selectedEntries.includes(id));

  const someSelected =
    entryIds.some((id) => selectedEntries.includes(id)) &&
    !allSelected;

  const toggleSelect = (id) => {
    const normalizedId = Number(id);

    setSelectedEntries((previousSelected) => {
      if (previousSelected.includes(normalizedId)) {
        return previousSelected.filter(
          (selectedId) => selectedId !== normalizedId
        );
      }

      return [...previousSelected, normalizedId];
    });
  };

  const toggleSelectAll = () => {
    setSelectedEntries((previousSelected) => {
      if (allSelected) {
        return previousSelected.filter(
          (selectedId) => !entryIds.includes(selectedId)
        );
      }

      return Array.from(
        new Set([...previousSelected, ...entryIds])
      );
    });
  };

  if (entries.length === 0) {
    return (
      <div className="entries-table-empty">
        Keine Einträge vorhanden.
      </div>
    );
  }

  return (
    <div className="entries-table-container">
      <table className="entries-table">
        <thead>
          <tr>
            <th className="checkbox-column">
              <input
                type="checkbox"
                checked={allSelected}
                ref={(checkbox) => {
                  if (checkbox) {
                    checkbox.indeterminate = someSelected;
                  }
                }}
                onChange={toggleSelectAll}
                aria-label="Alle Einträge auswählen"
              />
            </th>

            <th>Ort</th>
            <th>Zeit</th>
            <th>Tätigkeit</th>
          </tr>
        </thead>

        <tbody>
          {entries.map((entry) => {
            const entryId = Number(entry.id);
            const isSelected =
              selectedEntries.includes(entryId);

            return (
              <tr
                key={entry.id}
                className={isSelected ? "selected" : ""}
                onClick={() => toggleSelect(entryId)}
                aria-selected={isSelected}
              >
                <td className="checkbox-column">
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onClick={(event) => event.stopPropagation()}
                    onChange={() => toggleSelect(entryId)}
                    aria-label={`Eintrag ${entry.id} auswählen`}
                  />
                </td>

                <td data-label="Ort">
                  <div className="entry-location-cell">
                    <FaMapMarkerAlt />
                    <span>{entry.code || "Ohne Ortsangabe"}</span>
                  </div>
                </td>

                <td data-label="Zeit">
                  <div className="entry-time-cell">
                    <FaClock />
                    <span>{formatDate(entry.time)}</span>
                  </div>
                </td>

                <td data-label="Tätigkeit">
                  <span className="entry-activity-text">
                    {entry.activity || "Keine Tätigkeit angegeben"}
                  </span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <div className="table-selection-summary">
        {selectedEntries.length > 0
          ? `${selectedEntries.length} Einträge ausgewählt`
          : `${entries.length} Einträge`}
      </div>
    </div>
  );
};

const formatDate = (value) => {
  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return "Ungültiges Datum";
  }

  return date.toLocaleString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export default EntriesTable;